"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectProductionToLose = void 0;
var vue_1 = require("vue");
var PaymentWidgetMixin_1 = require("./PaymentWidgetMixin");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectProductionToLose = vue_1.default.component('select-production-to-lose', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            megacredits: 0,
            steel: 0,
            titanium: 0,
            plants: 0,
            energy: 0,
            heat: 0,
            warning: undefined,
        };
    },
    mixins: [PaymentWidgetMixin_1.PaymentWidgetMixin, TranslateMixin_1.TranslateMixin],
    methods: {
        canDeductMegaCredits: function () {
            return this.playerinput.payProduction.units.megacredits > -5;
        },
        canDeductSteel: function () {
            return this.playerinput.payProduction.units.steel > 0;
        },
        canDeductTitanium: function () {
            return this.playerinput.payProduction.units.titanium > 0;
        },
        canDeductPlants: function () {
            return this.playerinput.payProduction.units.plants > 0;
        },
        canDeductEnergy: function () {
            return this.playerinput.payProduction.units.energy > 0;
        },
        canDeductHeat: function () {
            return this.playerinput.payProduction.units.heat > 0;
        },
        hasWarning: function () {
            return this.$data.warning !== undefined;
        },
        delta: function (type, direction) {
            var expendableProductionQuantity = function (type, model) {
                switch (type) {
                    case 'megacredits':
                        return model.units.megacredits + 5;
                    case 'steel':
                        return model.units.steel;
                    case 'titanium':
                        return model.units.titanium;
                    case 'plants':
                        return model.units.plants;
                    case 'energy':
                        return model.units.energy;
                    case 'heat':
                        return model.units.heat;
                }
                return -1;
            };
            var current = this.$data[type];
            var newValue = current + direction;
            var lowestValue = (type === 'megacredit') ? -5 : 0;
            var expendableQuantity = expendableProductionQuantity(type, this.playerinput.payProduction);
            newValue = Math.min(Math.max(newValue, lowestValue), expendableQuantity);
            this.$data[type] = newValue;
        },
        saveData: function () {
            var htp = {
                megacredits: this.$data.megacredits,
                steel: this.$data.steel,
                titanium: this.$data.titanium,
                plants: this.$data.plants,
                energy: this.$data.energy,
                heat: this.$data.heat,
            };
            var sum = this.$data.megacredits +
                this.$data.steel +
                this.$data.titanium +
                this.$data.plants +
                this.$data.energy +
                this.$data.heat;
            if (sum !== this.playerinput.payProduction.cost) {
                this.$data.warning = "Pay a total of " + this.playerinput.payProduction.cost + " production units";
                return;
            }
            this.onsave([[
                    JSON.stringify(htp),
                ]]);
        },
    },
    template: "<div class=\"wf-component wf-component--select-production-to-lose\">\n        <div v-if=\"showtitle === true\" class=\"nofloat wf-component-title\">{{ $t(playerinput.title) }}</div>\n\n        <h3 class=\"payments_title\" v-i18n>Which resource production would you prefer to decrease?</h3>\n\n        <div class=\"payments_type input-group\" v-if=\"canDeductMegaCredits()\">\n          <div class=\"production-box\"><div class=\"production resource_icon--megacredits\" style=\"background-size:contain;\"></div></div>\n          <button class=\"btn btn-primary\" v-on:click=\"delta('megacredits', -1)\" :class=\"getCssClassFor('<', 'megacredit')\"><i class=\"icon icon-minus\" /></button>\n          <input class=\"form-input form-inline payments_input\" v-model.number=\"megacredits\" />\n          <button class=\"btn btn-primary\" v-on:click=\"delta('megacredits', 1)\" :class=\"getCssClassFor('>', 'megacredit')\"><i class=\"icon icon-plus\" /></button>\n        </div>\n        <div class=\"payments_type input-group\" v-if=\"canDeductSteel()\">\n          <div class=\"production-box\"><div class=\"production steel\"></div></div>\n          <button class=\"btn btn-primary\" v-on:click=\"delta('steel', -1)\" :class=\"getCssClassFor('<', 'steel')\"><i class=\"icon icon-minus\" /></button>\n          <input class=\"form-input form-inline payments_input\" v-model.number=\"steel\" />\n          <button class=\"btn btn-primary\" v-on:click=\"delta('steel', 1)\" :class=\"getCssClassFor('>', 'steel')\"><i class=\"icon icon-plus\" /></button>\n        </div >\n        <div class=\"payments_type input-group\" v-if=\"canDeductTitanium()\" >\n          <div class=\"production-box\"><div class=\"production titanium\"></div></div>\n          <button class=\"btn btn-primary\" v-on:click=\"delta('titanium', -1)\" :class=\"getCssClassFor('<', 'titanium')\"><i class=\"icon icon-minus\" /></button>\n          <input class=\"form-input form-inline payments_input\" v-model.number=\"titanium\" />\n          <button class=\"btn btn-primary\" v-on:click=\"delta('titanium', 1)\" :class=\"getCssClassFor('>', 'titanium')\"><i class=\"icon icon-plus\" /></button>\n        </div >\n        <div class=\"payments_type input-group\" v-if=\"canDeductPlants()\" >\n          <div class=\"production-box\"><div class=\"production plant\"></div></div>\n          <button class=\"btn btn-primary\" v-on:click=\"delta('plants', -1)\" :class=\"getCssClassFor('<', 'plants')\"><i class=\"icon icon-minus\" /></button>\n          <input class=\"form-input form-inline payments_input\" v-model.number=\"plants\" />\n          <button class=\"btn btn-primary\" v-on:click=\"delta('plants', 1)\" :class=\"getCssClassFor('>', 'plants')\"><i class=\"icon icon-plus\" /></button>\n        </div >\n        <div class=\"payments_type input-group\" v-if=\"canDeductEnergy()\" >\n          <div class=\"production-box\"><div class=\"production energy\"></div></div>\n          <button class=\"btn btn-primary\" v-on:click=\"delta('energy', -1)\" :class=\"getCssClassFor('<', 'energy')\"><i class=\"icon icon-minus\" /></button>\n          <input class=\"form-input form-inline payments_input\" v-model.number=\"energy\" />\n          <button class=\"btn btn-primary\" v-on:click=\"delta('energy', 1)\" :class=\"getCssClassFor('>', 'energy')\"><i class=\"icon icon-plus\" /></button>\n        </div >\n        <div class=\"payments_type input-group\" v-if=\"canDeductHeat()\" >\n          <div class=\"production-box\"><div class=\"production heat\"></div></div>\n          <button class=\"btn btn-primary\" v-on:click=\"delta('heat', -1)\" :class=\"getCssClassFor('<', 'heat')\"><i class=\"icon icon-minus\" /></button>\n          <input class=\"form-input form-inline payments_input\" v-model.number=\"heat\" />\n          <button class=\"btn btn-primary\" v-on:click=\"delta('heat', 1)\" :class=\"getCssClassFor('>', 'heat')\"><i class=\"icon icon-plus\" /></button>\n        </div >\n\n        <div v-if=\"hasWarning()\" class=\"tm-warning\">\n          <label class=\"label label-error\">{{ $t(warning) }}</label>\n        </div>\n  \n        <div v-if=\"showsave === true\" class=\"nofloat\">\n            <button class=\"btn btn-primary btn-submit\" v-on:click=\"saveData\">{{ $t(playerinput.buttonLabel) }}</button>\n        </div>\n    </div>",
});
//# sourceMappingURL=SelectProductionToLose.js.map